import React from "react";
import "./Services.css";
import Common_Banner from "../common_components/common_banner/Common_Banner";
import Maintenance from "./maintenance/Maintenance";
import Body_Repair from "./body_repair/Body_Repair";
import Outstation_Rides from "./outstation_rides/Outstation_Rides";
import Car_Wash from "./car_wash/Car_Wash";
import Inspection from "./insepection/Insepection";
import Pickup from "./pickup/Pickup";
import Towing from "./towing/Towing";
import Book_Vehicle from "../common_components/book_vehicle/Book_Vehicle";
import { useParams } from "react-router-dom";

const Services = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Home", link: "", isActive: true },
  ];

  const { type } = useParams();

  console.log("type", type);

  return (
    <>
      <Common_Banner
        imgSrc={"/assets/images/common_banners/about_banner.png"}
        title_text="Service"
        title_text2="Keeping Your Systems Running at Their Best."
        breadcrumbs={breadcrumbs}
      />

      <div className="Service_bg">
        {type === "maintenance" ? (
          <Maintenance />
        ) : type === "body-repair" ? (
          <Body_Repair />
        ) : type === "outstation-rides" ? (
          <Outstation_Rides />
        ) : type === "car-wash" ? (
          <Car_Wash />
        ) : type === "pickup" ? (
          <Pickup />
        ) : type === "inspection" ? (
          <Inspection />
        ) : type === "towing" ? (
          <Towing />
        ) : null}
        <Book_Vehicle />
      </div>
    </>
  );
};

export default Services;
